import React from 'react';
import { Dialog, Grid, Box, MenuItem } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import importStyles from './emailtemp.module.css';
import { CustomButton, CustomDialogAction, CustomDialogContent, CustomDialogTitle, CustomInputLabel, CustomTextField, InputProps, StyledCard, CustomSelect, SelectInputProps } from '../../../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const MailConfigModal = (props) => {

  const { mailFields, mailFieldsErrors, onChangeMail, editMail } = props;
  const MAIL_FIELDS_LIST = ['Pieces', 'Weight', 'O-D ', 'Commodity', 'FlightNumber', 'ArrivalDate', 'StorageStarts', 'StorageCost', 'Text', 'Hyperlink'];
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'mailConfig'} onClose={props.handleClose} maxWidth='sm' fullWidth={true}>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>{props.type == 'edit' ? 'Edit' : 'Add'} Mail Configuration
          <CloseIconBtn onClick={props.handleClose} />
        </CustomDialogTitle>
        <Box component='form' onSubmit={editMail}>
          <CustomDialogContent>
            <StyledCard>
              <Grid container spacing={1}>
                <Grid item xs>
                  <CustomInputLabel htmlFor='cc'>Body</CustomInputLabel>
                  <CustomSelect
                    {...SelectInputProps}
                    id='type'
                    name='type'
                    fullWidth
                    value={mailFields.type || ''}
                    onChange={onChangeMail}
                    error={mailFieldsErrors.type}
                  >
                    {MAIL_FIELDS_LIST.map((field, _, self) => (
                      <MenuItem key={field} value={field} disabled={field === 'Text' || field === 'Hyperlink' ? false : self.includes(field)}>{field}</MenuItem>
                    ))}
                  </CustomSelect>
                </Grid>
                {(mailFields.type === 'Text' || mailFields.type === 'Hyperlink') && (
                  <Grid item xs={12}>
                    <CustomInputLabel htmlFor='name' required>Name</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='name'
                      name='name'
                      value={mailFields.name}
                      onChange={onChangeMail}
                      error={mailFieldsErrors.name}
                      helperText={mailFieldsErrors.name}
                    />
                  </Grid>
                )}
                {(mailFields.type === 'Text' || mailFields.type === 'Hyperlink') && (
                  <Grid item xs={12}>
                    <CustomInputLabel htmlFor='value' required>{mailFields.type === 'Hyperlink' ? 'URL' : 'Value'}</CustomInputLabel>
                    {mailFields.type === 'Text' ? (
                      <ReactQuill
                        value={mailFields.value || ''}
                        onChange={(value) => onChangeMail({
                          target: {
                            name: 'value',
                            value 
                          } 
                        })}
                        modules={{
                          toolbar: [
                            ['bold', 'italic', 'underline'],
                            ['link']
                          ]
                        }}
                        formats={['bold', 'italic', 'underline', 'link']}
                        theme='snow'
                        className={mailFieldsErrors.value ? importStyles.quillError : ''}
                      />
                    ) : (
                      <CustomTextField
                        {...InputProps}
                        fullWidth
                        id='value'
                        name='value'
                        value={mailFields.value}
                        onChange={onChangeMail}
                        error={mailFieldsErrors.value}
                      />
                    )}
                  </Grid>
                )}
                {mailFields.type === 'Hyperlink' && (
                  <Grid item xs={12}>
                    <CustomInputLabel htmlFor='display_text'>Display Text (Optional)</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='display_text'
                      name='display_text'
                      value={mailFields.display_text || ''}
                      onChange={onChangeMail}
                      placeholder='Leave empty to show URL as link text'
                    />
                  </Grid>
                )}
              </Grid>
            </StyledCard>
          </CustomDialogContent>
          <CustomDialogAction className={styles.fSpaceBtw}>
            <CustomButton variant='contained' onClick={props.handleClose}>Close</CustomButton>
            <CustomButton type='submit' variant='contained' 
              className={` ${(mailFields.type === 'Text' || mailFields.type === 'Hyperlink') ? styles.mt2 : ''}`}>
                      Submit</CustomButton>
          </CustomDialogAction>
        </Box>
      </Dialog>
    </div>
  );
};
export default MailConfigModal;